import { render } from "./ConsumerDetailsCard.vue?vue&type=template&id=096962c8"
import script from "./ConsumerDetailsCard.vue?vue&type=script&lang=js"
export * from "./ConsumerDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__